export const STATO_COLORS = {
  "Da iniziare": "#94A3B8",
  "In Progress": "#3B82F6",
  "In Test": "#F59E0B",
  OK: "#10B981",
  KO: "#EF4444",
};

export const STATO_BADGE = {
  "Da iniziare": "bg-slate-100 text-slate-600 border-slate-200",
  "In Progress": "bg-blue-50 text-blue-700 border-blue-200",
  "In Test": "bg-amber-50 text-amber-700 border-amber-200",
  OK: "bg-emerald-50 text-emerald-700 border-emerald-200",
  KO: "bg-rose-50 text-rose-700 border-rose-200",
};

export const MILESTONE_BADGE = {
  Completata: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "In Orario": "bg-blue-50 text-blue-700 border-blue-200",
  "A Rischio": "bg-amber-50 text-amber-700 border-amber-200",
  "In Ritardo": "bg-rose-50 text-rose-700 border-rose-200",
  "Non iniziata": "bg-slate-100 text-slate-600 border-slate-200",
};

/** Stati che Dev e fornitore possono impostare: si fermano a "In Test". */
export const STATI_ESECUZIONE = ["Da iniziare", "In Progress", "In Test"];

export const ROLE_LABEL = {
  admin: "Admin / Super user",
  pm: "Majorbit · PM",
  dev: "Majorbit · Dev",
  tester: "Majorbit · Tester",
  fornitore: "Stefano Critelli",
  cliente_finale: "Infocamere",
};

export const ROLE_DESCR = {
  admin: "Configura clienti, profili, progetti e documentazione. Può tutto.",
  pm: "Sola lettura su tutto il progetto: avanzamenti, milestone e documenti.",
  dev: "Opera sui task e consolida le percentuali, fino allo stato In Test.",
  tester: "Valida i task in stato In Test dando OK o KO con le note di test.",
  fornitore: "Aggiorna i propri task: percentuale, stato fino a In Test e note.",
  cliente_finale: "Visibilità su milestone e avanzamenti, scarica tutta la documentazione.",
};

export const ROLE_BADGE = {
  admin: "bg-slate-900 text-white",
  pm: "bg-slate-100 text-slate-700 border border-slate-300",
  dev: "bg-amber-50 text-amber-700 border border-amber-200",
  tester: "bg-violet-50 text-violet-700 border border-violet-200",
  fornitore: "bg-indigo-50 text-indigo-700 border border-indigo-200",
  cliente_finale: "bg-teal-50 text-teal-700 border border-teal-200",
};

export const TIPO_ORG_LABEL = {
  fornitore: "Fornitore del cliente",
  cliente: "Cliente",
  cliente_finale: "Cliente finale",
};

export const ORG_LABEL = { fornitore: "Stefano Critelli", cliente: "Majorbit" };

export const ORG_BADGE = {
  fornitore: "bg-indigo-50 text-indigo-700 border-indigo-200",
  cliente: "bg-amber-50 text-amber-700 border-amber-200",
};

export const LOGOS = {
  governance:
    "https://static.prod-images.emergentagent.com/jobs/53b48e6f-4d5e-41d5-a97c-0fea894d05ae/images/fc6b9a13483c28bc8624ff9b6dcaab877333210fe1bfd18b7fbc72a0ca5b8c0a.jpeg",
  cliente:
    "https://static.prod-images.emergentagent.com/jobs/53b48e6f-4d5e-41d5-a97c-0fea894d05ae/images/bd66a14d265d1224c3805a648ebea3d801a3081136873d0fc73f3405644622dc.jpeg",
  fornitore:
    "https://static.prod-images.emergentagent.com/jobs/53b48e6f-4d5e-41d5-a97c-0fea894d05ae/images/1002a7792fc4d78f7a351673de29912cf8a10810684bd260e2074bcc37f3861e.jpeg",
  cliente_finale:
    "https://static.prod-images.emergentagent.com/jobs/53b48e6f-4d5e-41d5-a97c-0fea894d05ae/images/0406149df563ceb14c5d4128c206cd26b98b81769ba8a0db2106fd87da36fa02.jpeg",
};

export const ROLE_LOGO = {
  admin: LOGOS.governance,
  pm: LOGOS.cliente,
  dev: LOGOS.cliente,
  tester: LOGOS.cliente,
  fornitore: LOGOS.fornitore,
  cliente_finale: LOGOS.cliente_finale,
};

export const DEMO_ACCOUNTS = [
  { role: "admin", label: "Admin / Super user", org: "Governance", email: "stefanocritelli5@gmail.com", password: "Rigenera2026!", logo: LOGOS.governance },
  { role: "fornitore", label: "Stefano Critelli", org: "Fornitore", email: "fornitore@rigenera.it", password: "fornitore123", logo: LOGOS.fornitore },
  { role: "pm", label: "PM", org: "Majorbit", email: "pm@majorbit.it", password: "pm123", logo: LOGOS.cliente },
  { role: "dev", label: "Dev", org: "Majorbit", email: "dev@majorbit.it", password: "dev123", logo: LOGOS.cliente },
  { role: "tester", label: "Tester", org: "Majorbit", email: "tester@majorbit.it", password: "tester123", logo: LOGOS.cliente },
  { role: "cliente_finale", label: "Infocamere", org: "Cliente finale", email: "infocamere@rigenera.it", password: "infocamere123", logo: LOGOS.cliente_finale },
];

export const CATEGORIE_DOC = [
  "Analisi funzionale",
  "Analisi tecnica",
  "Plan",
  "Piano interno",
  "NDA e Termini",
  "Verbale / Review",
  "Altro",
];

export const VISIBILITA_DOC = [
  { v: "fornitore", l: "Stefano Critelli" },
  { v: "pm", l: "Majorbit PM" },
  { v: "dev", l: "Majorbit Dev" },
  { v: "tester", l: "Majorbit Tester" },
  { v: "cliente_finale", l: "Infocamere" },
];

export const FIRMA = "Realizzato da Stefano Critelli";

export const PM_ROBOT =
  "https://static.prod-images.emergentagent.com/jobs/53b48e6f-4d5e-41d5-a97c-0fea894d05ae/images/3bb956ba94720bc83f62c9766ac5b0af03fe067168d58f137001d3fd6e8d60d1.jpeg";
export const PM_ROBOT_AVATAR =
  "https://static.prod-images.emergentagent.com/jobs/53b48e6f-4d5e-41d5-a97c-0fea894d05ae/images/7f1f59a4106ea02b609335b4fe952e4403a34023a92001f287e802b02dd206a4.jpeg";

export const SEMAFORO = {
  verde: { label: "Sprint in linea", box: "border-emerald-200 bg-emerald-50", text: "text-emerald-700" },
  giallo: { label: "Attenzione richiesta", box: "border-amber-200 bg-amber-50", text: "text-amber-700" },
  rosso: { label: "Sprint a rischio", box: "border-rose-200 bg-rose-50", text: "text-rose-700" },
};


export const fmtDateTime = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};
